export const setupApiProtection = async () => {
    const response = await fetch("/api/csrf", {
        credentials: "include", // Important for session cookie
    })

    const { csrfToken, expires } = await response.json()
    localStorage.setItem("csrfExpires", expires)

    return {
        headers: {
            "x-csrf-token": csrfToken,
            "Content-Type": "application/json",
        },
    }
}
